import {addAuthToFetchOpts} from '../config/queryopts'
import {useMutationWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";
import {useQueryClient} from "react-query";


export const AddAnalysisFetcher = (accessToken, params) => {
  return axios.post(`${apiUrlInternal}/analyses`, params, addAuthToFetchOpts(accessToken, {}, 0)).then(res => res.data);
}

export const useAddAnalysisMutation = (fetcher = AddAnalysisFetcher) => {
  const queryClient = useQueryClient();
  return useMutationWithAuthentication(
    ['add-analysis'],
    (accessToken, params) => fetcher(accessToken, params),
    {onSuccess: () => queryClient.invalidateQueries('add-analysis')}
  )
}

